export function initSingleInteractions() {
    const headerImg = document.querySelector('.single .headimg img');
    const bar = document.getElementById('read-progress');

    // Nothing there.
    if (!headerImg && !bar) return;

    // NOTE: Responsive 16:9 iframes are handled via CSS (aspect-ratio) to avoid runtime measurements.

    // Cached measurements (updated on resize/load only)
    let headerHeight = 0;
    let imgHeight = 0;
    let totalHeight = 1; // prevent divide-by-zero
    let docHeight = 0;
    let viewport = 0;

    function measureStatic() {
        // Measure heights that don't change every scroll
        const header = document.querySelector('#header');
        headerHeight = header ? header.offsetHeight : 0;
        imgHeight = headerImg ? headerImg.offsetHeight : 0;
        totalHeight = Math.max(1, headerHeight + imgHeight);

        // Document/viewport for progress
        const bodyEl = document.querySelector('div.body');
        const docFromBody = bodyEl ? bodyEl.scrollHeight : 0;
        const docFromDoc = Math.max(
            document.body ? document.body.scrollHeight : 0,
            document.documentElement ? document.documentElement.scrollHeight : 0
        );
        docHeight = Math.max(docFromBody, docFromDoc);
        viewport = window.innerHeight || document.documentElement.clientHeight || 0;
    }

    // --- Animate header image opacity and position on scroll (compositor-friendly) ---
    function writeHeaderAndProgress(y) {
        if (headerImg) {
            // Use transform instead of top/margin to avoid layout
            const translateY = y / 2; // parallax amount
            headerImg.style.transform = `translateY(${translateY}px)`;

            // Fade based on totalHeight
            const opacity = Math.max(0, Math.min(1, 1 - y / totalHeight));
            headerImg.style.opacity = String(opacity);
            // Make sure the element is optimized by the compositor
            if (!headerImg.style.willChange) {
                headerImg.style.willChange = 'transform, opacity';
            }
        }

        if (bar) {
            const maxScroll = Math.max(1, docHeight - viewport);
            const progress = Math.max(0, Math.min(100, (y / maxScroll) * 100));
            bar.style.width = `${progress}%`;
        }
    }

    // rAF scroll batching
    let ticking = false;
    function onScroll() {
        const y = window.scrollY || document.documentElement.scrollTop || 0;
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(() => {
                writeHeaderAndProgress(y);
                ticking = false;
            });
        }
    }

    // Initial measurements and paint
    measureStatic();
    writeHeaderAndProgress(window.scrollY || document.documentElement.scrollTop || 0);

    // Re-measure on resize and when the header image loads (if not cached yet)
    window.addEventListener('resize', () => {
        measureStatic();
        // After resize, update with current scroll
        onScroll();
    });
    if (headerImg) {
        if (headerImg.complete) {
            measureStatic();
        } else {
            headerImg.addEventListener('load', () => {
                measureStatic();
                onScroll();
            });
        }
    }

    // --- Event listeners ---
    window.addEventListener('scroll', onScroll, { passive: true });
}